

























































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import {
  instanceOfIEditFixedPhrase,
  TemporarySaveUserFixedPhraseSelector,
} from "../fixedPhrase";
import { FixedPhraseReference } from "../../../domain/document";
import { FixedLoading } from "../../system";

@Component({
  components: {
    TemporarySaveUserFixedPhraseSelector,
    FixedLoading,
  }
})
export default class DocumentNoteDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      isConfirmed: false,
      isEdit: false,
      note: "",
      isFixedPhrase: false,
      selectedFixedPhrase: null as FixedPhraseReference,
      title: "",
      additionalDescription: "",
      saveButtonLabel: "",
      isFixedPhraseEditing: false,
    };
  }
  isConfirmed: boolean;
  isEdit: boolean;
  note: string;
  isFixedPhrase: boolean;
  selectedFixedPhrase: FixedPhraseReference;
  title: string;
  additionalDescription: string;
  saveButtonLabel: string;
  isFixedPhraseEditing: boolean;

  get dialogWidth(): string {
    return this.isFixedPhrase
      ? "650px"
      : "400px";
  }
  get userId(): string {
    return this.$store.getters.user.id;
  }

  async show(isEdit: boolean, note: string, isFixedPhrase: boolean, title: string, additionalDescription: string = "", saveButtonLabel: string = ""): Promise<string> {
    return this.showModal(async () => {
      this.isConfirmed = false;
      this.isEdit = isEdit;
      this.note = note
        ? note
        : "";
      this.isFixedPhrase = isFixedPhrase;
      this.selectedFixedPhrase = null;
      this.title = title;
      this.additionalDescription = additionalDescription;
      this.saveButtonLabel = saveButtonLabel ? saveButtonLabel : "保存する";
      if (this.isEdit) {
        await this.$nextTick();
        const textarea = this.$refs.textarea;
        if (textarea instanceof HTMLTextAreaElement) {
          textarea.focus();
          if (textarea.value && textarea.value.length) {
            const textLength = textarea.value.length;
            textarea.setSelectionRange(textLength, textLength);
          }
        }
      }
      await this.waitHidden();
      return this.isConfirmed
        ? this.note
        : null;
    });
  }

  pasteFixedPhrase(): void {
    const textarea = this.$refs.textarea;
    if (textarea instanceof HTMLTextAreaElement) {
      const text = textarea.value;
      const index = textarea.selectionStart
        ? textarea.selectionStart
        : text.length;
      const inserted = text.slice(0, index)
        + this.selectedFixedPhrase.text
        + text.slice(index);
      this.note = inserted;
    }
  }

  dragOver(event: DragEvent): void {
    event.stopPropagation();
    event.dataTransfer.effectAllowed = "copy";
  }

  editFixedPhrase(): void {
    const tree = this.$refs.fixedPhrase;
    if (instanceOfIEditFixedPhrase(tree) && !this.isFixedPhraseEditing) {
      this.isFixedPhraseEditing = true;
      tree.editFixedPhrase()
      .finally(() => {
        this.isFixedPhraseEditing = false;
      });
    }
  }

  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
